import { useDispatch, useSelector } from 'react-redux';
import { selectLead, selectLeadLoader, updateLead } from '../../redux/features/expressSheild/leadSlice';

const useUpdateLead = () => {
    const dispatch = useDispatch();
    const leadData = useSelector(selectLead);
    const leadLoader = useSelector(selectLeadLoader);

    const updateLeadHandler = (payload = {}) => {
        // Lead tracking runs alongside the customer's step, not in its way.
        // With no lead on record (the create call failed, or the page was
        // reloaded past Basic Info) there is nothing to update, and throwing
        // here would take the step down with it.
        if (!leadData?.lead_id) return
        let data = {
            lead_id: leadData.lead_id,
            status: 0,
            ...payload
        }
        dispatch(updateLead(data))
    }
    return {updateLeadHandler, leadLoader}
}

export default useUpdateLead